import React, { Suspense } from "react";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './i18n';
import BackdropLoader from "./components/UI/BackdropLoader";

const theme = createTheme({
  palette: {
    primary: {
      main: '#019cde'
    }
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
    h1: {
      color: '#061645'
    },
    h2: {
      color: '#061645'
    },
    h3: {
      color: '#061645'
    },
    h4: {
      color: '#061645'
    },
    h5: {
      color: '#061645'
    },
    h6: {
      color: '#061645'
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Suspense fallback={<BackdropLoader />}>
        <App />
      </Suspense>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
